import React, { Component, Fragment } from "react";
import IntlMessages from "../helpers/IntlMessages";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar } from "react-modern-calendar-datepicker";
import moment from "moment";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import AmaduesAvailability from "./AmaduesAvailability";
import MewsAvailability from "./MewsAvailability";
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const BMB_Property_URL = process.env.REACT_APP_API_URL + "/property";
const BMB_BOOKING_ENGINE =
  process.env.REACT_APP_API_URL + "/booking-engine-data";
export default class CheckAvailablity extends Component {
  constructor(props) {
    super(props);
    this.handleAdultsChange = this.handleAdultsChange.bind(this);
    this.handleChildrenChange = this.handleChildrenChange.bind(this);
    this.submit = this.submit.bind(this);
    this.setSelectedDayRange = this.setSelectedDayRange.bind(this);
    this.calculateNights = this.calculateNights.bind(this);
    this.handleChangeChildrenAge = this.handleChangeChildrenAge.bind(this);
    this.handlePromoCodeChange = this.handlePromoCodeChange.bind(this);
    this.state = {
      active: this.props.open_availblity_popup,
      minimumDate: {
        year: moment().add(1, "days").year(),
        month: moment().add(1, "days").month() + 1,
        day: moment().add(1, "days").date(),
      },
      selectedDayRange: {
        from: {
          year: moment().add(15, "days").year(),
          month: moment().add(15, "days").month() + 1,
          day: moment().add(15, "days").date(),
        },
        to: {
          year: moment().add(17, "days").year(),
          month: moment().add(17, "days").month() + 1,
          day: moment().add(17, "days").date(),
        },
      },
      adults: 2,
      children: 0,
      nights: 0,
      children_age: [],
      propertyCurrency: '',
      promoCode: "",
      integration: undefined,
      dates: null,
      roomdata: null,
      roomId: this.props.data.roomId
    };
  }

  componentDidMount() {
    // console.log('data', this.state.availabityData)
    // let fromDateStr =
    //   this.state.selectedDayRange.from.year +
    //   "-" +
    //   this.state.selectedDayRange.from.month +
    //   "-" +
    //   this.state.selectedDayRange.from.day;
    // let toDateStr =
    //   this.state.selectedDayRange.to.year +
    //   "-" +
    //   this.state.selectedDayRange.to.month +
    //   "-" +
    //   this.state.selectedDayRange.to.day;
    // const fromDate = moment(fromDateStr).format(this.props.data.dateFormat);
    // const toDate = moment(toDateStr).format(this.props.data.dateFormat);
    fetch(process.env.REACT_APP_API_URL + "/properties/" + this.props.data.pid + "/rooms?languagecode=" + this.props.lang, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then(json => {
        this.setState({ roomdata: json.rooms });
      });
    var dates = this.state.selectedDayRange;
    var fromDate = "";
    var toDate = "";
    if (dates.from !== null) {
      fromDate = moment({ year: dates.from.year, month: dates.from.month - 1, day: dates.from.day }).format("YYYY-MM-DD");
    }
    if (dates.to !== null) {
      toDate = moment({ year: dates.to.year, month: dates.to.month - 1, day: dates.to.day }).format("YYYY-MM-DD");
    }
    this.setState({
      dates: { fromDate: fromDate, toDate: toDate }
    });
    let nights = this.calculateNights(fromDate, toDate);
    this.setState({ nights: nights });
    fetch(
      BMB_Property_URL +
      "/" +
      this.props.data.pid +
      "?groupId=" +
      this.props.data.gid +
      "",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.property !== undefined && json.property.currency !== undefined) {
          this.setState({ propertyCurrency: json.property.currency });
        }
      });
    fetch(
      process.env.REACT_APP_API_URL +
      "/find-amadues?groupId=" +
      this.props.data.gid +
      "&propertyId=" +
      this.props.data.pid,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.Found === true && json.ShowRates === true) {
          this.setState({ integration: json });
        }
      });

    fetch(
      process.env.REACT_APP_API_URL +"/find-by-property?groupId=" +
      this.props.data.gid +
      "&propertyId=" +
      this.props.data.pid,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.Found === true && json.ShowRates === true) {
          this.setState({ integration: json });
        }
      });
    const { buttonColor, messengerSetting } = this.props;
    
    const buttonColorset = messengerSetting?.calendarButtonColor ?? buttonColor ?? "#0eca2d";
    const textColorset = messengerSetting?.calendarTextColor ?? buttonColor ?? '#ffffff';
    const selectedButtonColor = messengerSetting?.selectedButtonColor ?? '#d3d3d3';
    const selectedTextColor = messengerSetting?.selectedTextColor ?? '#ffffff';
    const borderRadius = (messengerSetting?.calendarLayout === 'Square Edges') ? '0px' : '20px';
    // console.log('msngrset', messengerSetting, buttonColorset, selectedButtonColor);
    
     document.documentElement.style.setProperty('--calendar-button-color', buttonColorset);
     document.documentElement.style.setProperty('--calendar-text-color', textColorset);
     document.documentElement.style.setProperty('--calendar-selected-button-color', selectedButtonColor);
     document.documentElement.style.setProperty('--calendar-selected-text-color', selectedTextColor);
     document.documentElement.style.setProperty('--calendar-border', borderRadius);

 
   }
  
  
  handleAdultsChange = (e) => {
    this.setState({ adults: e.target.value });
  };
  handleChildrenChange = (e) => {
    this.setState({ children: e.target.value });
    if (this.props.data.bookingEngineUrl.includes("{CHILDREN_AGE}")) {
      let childrenValue = parseInt(e.target.value);
      let childrenAge = [...this.state.children_age];
      if (childrenAge.length > childrenValue) {
        let arr = [];
        for (var i = 0; i < childrenValue; i++) {
          arr.push(childrenAge[i]);
        }
        childrenAge = arr;
      } else {
        for (var i = childrenAge.length; i < childrenValue; i++) {
          childrenAge.push({
            id: i + 1,
            ["children_age_" + (i + 1)]: "",
          });
        }
      }
      this.setState({ children_age: childrenAge });
    }
  };
  handleChangeChildrenAge(e, id) {
    let childrenAge = [...this.state.children_age];
    childrenAge = this.state.children_age.map((item) => {
      if (item.id === id) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return { ...item };
      }
    });

    this.setState({ children_age: childrenAge });
  }

  handlePromoCodeChange = (e) => {
    this.setState({ promoCode: e.target.value });
  };
  setSelectedDayRange(dates) {
    this.setState({ selectedDayRange: dates });
    var fromDate = "";
    var toDate = "";
    if (dates.from !== null) {
      fromDate = moment({ year: dates.from.year, month: dates.from.month - 1, day: dates.from.day }).format("YYYY-MM-DD");
    }
    if (dates.to !== null) {
      toDate = moment({ year: dates.to.year, month: dates.to.month - 1, day: dates.to.day }).format("YYYY-MM-DD");
    }
    this.setState({
      dates: { fromDate: fromDate, toDate: toDate }
    });
    let night = 0;
    if (dates.from !== null && dates.to !== null) {
      let fromDateStr =
        dates.from.year + "-" + dates.from.month + "-" + dates.from.day;
      let toDateStr = dates.to.year + "-" + dates.to.month + "-" + dates.to.day;
      const fromDate = moment(fromDateStr).format("YYYY-MM-DD");
      const toDate = moment(toDateStr).format("YYYY-MM-DD");
      night = this.calculateNights(fromDate, toDate);
    }
    this.setState({ nights: night });
  }
  calculateNights(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    let dayCount = 0;
    while (end > start) {
      dayCount++;
      start.setDate(start.getDate() + 1);
    }
    return dayCount;
  }

  submit() {
    const data = this.props.data;
    // let fromDateStr =
    //   this.state.selectedDayRange.from.year +
    //   "-" +
    //   this.state.selectedDayRange.from.month +
    //   "-" +
    //   this.state.selectedDayRange.from.day;
    // let toDateStr =
    //   this.state.selectedDayRange.to.year +
    //   "-" +
    //   this.state.selectedDayRange.to.month +
    //   "-" +
    //   this.state.selectedDayRange.to.day;
    // const fromDate = moment(fromDateStr).format(data.dateFormat);
    // const toDate = moment(toDateStr).format(data.dateFormat);
    // console.log(this.state.dates);
    const fromDate = this.state.dates.fromDate;
    const toDate = this.state.dates.toDate;
    let childAge = "";
    let childrenAge = this.state.children_age;
    if (childrenAge.length > 0) {
      childrenAge.map((item, index) => {
       childAge += item["children_age_" + (index + 1)];
        if (item["children_age_" + (index + 1)] !== "" && childAge !== "" && childrenAge.length > (index + 1)) {
          childAge += data.delimiter;
        }
      });
    }
    let bookingUrl = data.bookingEngineUrl;
    if (this.state.children === 0) {
      if (bookingUrl.includes("{ADULTS}-{CHILDREN_AGE}")) {
        bookingUrl = bookingUrl.replace(
          "{ADULTS}-{CHILDREN_AGE}",
          "{ADULTS}{CHILDREN_AGE}"
        );
      }
    }
    bookingUrl = bookingUrl.replace(
      "{CHECK_IN}",
      moment(fromDate).format(this.props.data.dateFormat)
    );
    bookingUrl = bookingUrl.replace(
      "{CHECK_OUT}",
      moment(toDate).format(this.props.data.dateFormat)
    );
    bookingUrl = bookingUrl.replace("{ADULTS}", this.state.adults);
    bookingUrl = bookingUrl.replace("{CHILDREN}", this.state.children);
    bookingUrl = bookingUrl.replace("{LANGUAGE}", this.props.lang);
    bookingUrl = bookingUrl.replace("{ROOM_TYPE}", data.roomBookingEngineCode);
    bookingUrl = bookingUrl.replace("{NIGHTS}", this.state.nights);
    bookingUrl = bookingUrl.replace("{CHILDREN_AGE}", childAge);
    bookingUrl = bookingUrl.replace("{PROMO_CODE}", this.state.promoCode);
    var body = {
      groupId: this.props.data.gid,
      propertyId: this.props.data.pid,
      checkInDate: moment(fromDate).format("YYYY-MM-DD"),
      checkOutDate: toDate !== "" ? moment(toDate).format("YYYY-MM-DD") : "",
      nights: this.state.nights,
      adults: this.state.adults,
      childrens: this.state.children,
      creator: "webview",
      promoCode: this.state.promoCode,
    };
    let msg = "Customer referred to the booking page for dates";
    msg +=
      " " +
      months[this.state.selectedDayRange.from.month - 1] +
      " " +
      this.state.selectedDayRange.from.day +
      ", " +
      this.state.selectedDayRange.from.year +
      " to " +
      months[this.state.selectedDayRange.to.month - 1] +
      " " +
      this.state.selectedDayRange.to.day +
      ", " +
      this.state.selectedDayRange.to.year +
      "";
    if (this.state.adults !== 0) {
      msg += ", for " + this.state.adults + " adults";
    }
    if (this.state.children !== 0) {
      msg += " and " + this.state.children + " children";
    }
    this.props.api.sendActivity({
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "webchat/booking",
        value: {
          msg: `${msg}`,
        },
      },
    });
    fetch(`${BMB_BOOKING_ENGINE}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    this.props.addLinks(bookingUrl);
    this.props.closeAvailblityForm();
    if (window.parent) {
      window.parent.postMessage("openUrl:" + bookingUrl + "", "*");
    } else {
      window.location = bookingUrl;
    }
  }

  render() {
   
    return (
      <Fragment>
        {this.state.integration === undefined ? (
          <div className="chat_box_popup_new">
            <div className="endchat_popup area">
              <h1 className="availablityh1">
                {""}
                {this.state.roomdata && this.state.roomdata.filter(l => l.id === this.state.roomId).length > 0 ?
                  this.state.roomdata.filter(l => l.id === this.state.roomId)[0].name :
                  <IntlMessages id="check.availabity" />
                }
                {""}
                  <img style={{float: 'right'}}  onClick={this.props.closeAvailblityForm} src="/res/cross_icon.jpg" width="15" height="15" />
              </h1>
              <Row>
                <Col xs={12}>
                  <Calendar
                    value={this.state.selectedDayRange}
                    minimumDate={this.state.minimumDate}
                    onChange={this.setSelectedDayRange}
                    style={{ height: "32.7em" }}
                  />
              
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={6} style={{ margin: "0" }}>
                  <FormGroup>
                    <Label>
                      <IntlMessages id="check.availabity.adults" />
                    </Label>
                    <Input
                      type="select"
                      name="adults"
                      value={this.state.adults}
                      onChange={this.handleAdultsChange}
                    >
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col xs={6} style={{ margin: "0" }}>
                  <FormGroup>
                    <Label>
                      <IntlMessages id="check.availabity.children" />
                    </Label>
                    <Input
                      type="select"
                      name="children"
                      value={this.state.children}
                      onChange={this.handleChildrenChange}
                    >
                      <option>0</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                    </Input>
                  </FormGroup>
                </Col>
                {this.state.children_age.length > 0 &&
                  this.state.children_age.map((element, i) => (
                    <Col xs={4} style={{ margin: "0" }} key={i}>
                      <FormGroup>
                        <Label>
                          <IntlMessages id="check.availabity.child.age" />{" "}
                          {i + 1}
                        </Label>
                        <Input
                          type="select"
                          name={"children_age_" + (i + 1)}
                          value={element[i]}
                          onChange={(e) =>
                            this.handleChangeChildrenAge(e, element.id)
                          }
                        >
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                          <option>11</option>
                          <option>12</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  ))}
              </Row>
              {this.props.data.bookingEngineUrl.includes("{PROMO_CODE}") && (
                <Row>
                  <Col xs={12} style={{ margin: "0" }} className="mb-3">
                    <Input
                      type="text"
                      value={this.state.promoCode}
                      placeholder={"Promo Code"}
                      onChange={this.handlePromoCodeChange}
                    />
                  </Col>
                </Row>
              )}
              <button
                className="availablity_button"
                style={{ backgroundColor: this.props.buttonColor ? this.props.buttonColor : '#0eca2d', borderColor: this.props.buttonColor ? this.props.buttonColor : '#0eca2d' }}
                // style={{ backgroundColor: "#0eca2d" }}
                onClick={this.submit}
              >
                {""}
                Book Now
                {""}
              </button>
              <button
                className="cancelchat_button"
                onClick={this.props.closeAvailblityForm}
              >
                {""}
                <IntlMessages id="check.availabity.cancel" />
                {""}
              </button>
            </div>
          </div>
        ) : (
          <Fragment>
            {this.state.integration?.Channel && (this.state.integration.Channel === "Mews"|| this.state.integration.Channel === "SHRCRS")  ? (
              <MewsAvailability
                api={this.props.api}
                integration={this.state.integration}
                data={this.props.data}
                open_availblity_popup={this.state.open_availblity_popup}
                closeAvailblityForm={this.props.closeAvailblityForm}
                botSettings={this.props.botSettings}
                lang={this.state.language}
                addLinks={this.props.addLinks}
                gid={this.props.gid}
                propertyCurrency={this.state.propertyCurrency}
                pid={this.props.pid}
                buttonColor={this.props.buttonColor}
                roomdata={this.state.roomdata}
              ></MewsAvailability>
            ) : (
              <AmaduesAvailability
                api={this.props.api}
                integration={this.state.integration}
                data={this.props.data}
                open_availblity_popup={this.state.open_availblity_popup}
                closeAvailblityForm={this.props.closeAvailblityForm}
                botSettings={this.props.botSettings}
                lang={this.state.language}
                addLinks={this.props.addLinks}
                gid={this.props.gid}
                pid={this.props.pid}
                buttonColor={this.props.buttonColor}
                roomdata={this.state.roomdata}
              ></AmaduesAvailability>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
